import { MockupScene } from '@api-ui-app/src/app/mockup-studio/types/mockup-studio-scenes';

const FLAT_PREVIEW_TAG = 'Flat Preview';

export const getRelevantSupportedPreviewScenes = (
  mockupScenes: MockupScene[],
  hasUsedShutterstockAssets: boolean,
): MockupScene[] => {
  if (hasUsedShutterstockAssets) {
    const filteredMockupScenes = mockupScenes.filter(
      mockupScene => !(mockupScene?.tags || []).includes(FLAT_PREVIEW_TAG),
    );

    // EIN-2116: Fix for calendars and other products having only one default preview scene available
    if (filteredMockupScenes?.length > 0) {
      return filteredMockupScenes;
    }
  }

  return mockupScenes;
};
